<template>
  <div>
    <Toast />
    <div class="half-background"  v-if="$route.path != '/login' && !$route.path.includes('/msauth') && !$route.path.includes('/onboarding/') && !$route.path.includes('reset-password') && !$route.path.includes('/feature-flags')"></div>
    <Navbar style='z-index: 1' v-if="$route.path != '/login' && !$route.path.includes('/msauth') && !$route.path.includes('/onboarding/') && !$route.path.includes('reset-password') && !$route.path.includes('/feature-flags')" />
    <TimeRunnerModal v-if="$store.state.displayTimeRunnerModal" />
    
    <router-view></router-view>
    <AlertsPanel v-click-outside="() => hideAlerts()" v-if="$route.path != '/login' && !$route.path.includes('/msauth') && !$route.path.includes('/feature-flags') && $route.name != 'Prescriber Onboarding' && $store.state.displayAlerts" />
  </div>
</template>

<script>
import Navbar from './components/navigation/Navbar.vue';
import TimeRunnerModal from '@/components/modals/TimeRunnerModal.vue';
import AlertsPanel from './components/notifications/AlertsPanel.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    TimeRunnerModal,
    AlertsPanel
  },
  data(){
    return{
      checkedCache: false,
      loggedIn: false,
    }
  },
  created(){
    },
  methods:{
    hideAlerts() {
      this.$store.commit('setDisplayAlerts', false);
    }
  },
  mounted(){
    localStorage.removeItem('reg');
    this.$store.dispatch('timeRunner');
    console.log('mounting the app');
    this.$store.commit('setAlerts', null);
    // Kraken rejects /get-alerts with 400 when the Location header is empty, which is what the
    // store initialises it to on a cold load with no stored locations. Gate, don't remove: on a
    // hard refresh of an authenticated session this is the only thing that loads alerts.
    if (this.$store.state.header.headers['Location']) {
      this.$store.dispatch('getAlerts');
    }
    //  Auto Sync of Invoice, Orders, Clients, Suppliers, StockTake 
    // this.$store.dispatch('syncHourly');
  },
  computed:{
  }
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.half-background{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 400px;
    z-index: -1;
    background-image: linear-gradient(to right, #0ddcf3 , #0973dd);
}
</style>
